import {ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnInit, Output} from "@angular/core";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {FormBuilder, FormControl} from "@angular/forms";
import {select} from "@angular-redux/store";
import {WithdrawalConsumerInterface} from "../../model/withdrawal-consumer-interface.type";
import {ApolloQueryObservable} from "apollo-angular";
import {WithdrawalService} from "../../services/withdrawal.service";
import {appInjector} from "../../../index";
import {Observable} from "rxjs/Observable";
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: 'vb-withdrawal-consumer-selection',
  templateUrl: './withdrawal-consumer-selection.component.html',
  styleUrls: ['./withdrawal-consumer-selection.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => WithdrawalConsumerSelectionComponent)}]
})
export class WithdrawalConsumerSelectionComponent extends AbstractVisbosControl<WithdrawalConsumerInterface, FormControl> implements OnInit {

  @select(['session', 'activeAdminUnit']) adminUnitCuid$: Observable<string>;

  private _selectedConsumerCuid: string;

  get selectedConsumerCuid(): string {
    return this._selectedConsumerCuid;
  }

  @Input()
  set selectedConsumerCuid(value: string) {
    this._selectedConsumerCuid = value;
    if(this.consumerList && this.control) {
      this.item = this.consumerList.find(consumer => consumer.cuid == this.selectedConsumerCuid);
      this.control.setValue(this.item ? this.item.cuid : undefined);
    }
  }

  @Output()
  consumerSelected: EventEmitter<WithdrawalConsumerInterface> = new EventEmitter<WithdrawalConsumerInterface>();

  private consumerList$: ApolloQueryObservable<WithdrawalConsumerInterface[]>;
  consumerList: WithdrawalConsumerInterface[] = [];
  private consumerListSub: Subscription;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef,
              private wdService: WithdrawalService) {
    super(fb, cd, null);
  }

  ngOnInit() {
    super.ngOnInit();

    this.consumerList$ = null;
    this.consumerListSub = this.consumerList$.subscribe((depots: any) => {
      this.consumerList = depots;
      if(this.selectedConsumerCuid) {
        this.item = this.consumerList.find(dl => dl.cuid == this.selectedConsumerCuid);
        this.control.setValue(this.item ? this.item.cuid : undefined);
      }
    });

  }

  ngOnDestroy(): void {
    this.consumerListSub.unsubscribe();
  }

  buildControlContent(): FormControl {
    return WithdrawalConsumerSelectionComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormControl {
    fb = fb ? fb : appInjector().get(FormBuilder);
    return fb.control(null);
  }

  onConsumerSelected(consumer: WithdrawalConsumerInterface) {
    this.consumerSelected.emit(consumer);
  }

  public setDefaultValues(item?: WithdrawalConsumerInterface): {[controlKey: string]: any} | any {
    return this.setValue(item, 'cuid');
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/withdrawal/withdrawal-consumer-selection/withdrawal-consumer-selection.component.ts